export default {
  name: 'table-column-input',
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    columnKey: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    stylingClasses: {
      type: Array,
      default: []
    },
    elAttribute: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      inputValue: this.value
    }
  },
  methods: {
    onChange () {
      this.$emit('change', {
        value: this.inputValue,
        columnKey: this.columnKey,
        index: this.index,
        id: this.id
      })
    },
    onFocus () {
      this.$emit('focus', {
        value: this.inputValue,
        columnKey: this.columnKey,
        index: this.index,
        id: this.id
      })
    },
    onBlur () {
      this.$emit('blur', {
        value: this.inputValue,
        columnKey: this.columnKey,
        index: this.index,
        id: this.id
      })
    },
    onEnter () {
      this.$emit('enter', {
        value: this.inputValue,
        columnKey: this.columnKey,
        index: this.index,
        id: this.id
      })
    }
  }
}
